import { auth } from '@/utils/auth'
export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem('user'))
  },
  getters: {
    user: (state) => {
      return JSON.parse(localStorage.getItem('user'))
    },
  },
  mutations: {
    setUser(state, user) {
      localStorage.setItem('user', JSON.stringify(user))
      state.user = user
      console.log(user)
    },
  },
  actions: {
    logout({ commit }) {
      commit('setUser', null)
      auth.removeToken()
    }
  }
}

